<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical
        headerTitle="안전보건체계 출력"
        headerTitleTooltip="최대 5분동안 문서를 제작합니다. 네트워크 에러 발생 시 관리자에게 문의하세요."
        device="web"
        :IsUseInfo="true"
      >
        <template v-slot:Info>
          <span v-if="isDownLoading" class="error--text d-flex align-center mr-2">{{
            `문서를 제작중입니다. 잠시만 기다려 주세요. (${elapsedTimeText} 경과)`
          }}</span>
          <v-row class="align-center">
            <v-switch v-model="splitPrint" class="d-flex align-center">
              <template v-slot:label>
                <span class="ml-2 main_text--text switch-label">{{ splitPrint ? '분할 출력' : '전체 출력' }}</span>
              </template>
            </v-switch>
            <v-tooltip top color="primary" max-width="400px">
              <template v-slot:activator="{ on }">
                <span class="editor-label ml-2 d-flex align-center">
                  <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                </span>
              </template>
              <div
                class="tooltip-text"
                v-html="
                  splitPrint
                    ? '분할 출력: TBM, 작업계획서 등 일자별 문서를 일자별로 분할하여 별첨으로 첨부하여 출력합니다.'
                    : '전체 출력: 문서를 하나의 파일로 합쳐 출력합니다.'
                "
              ></div>
            </v-tooltip>
          </v-row>
        </template>
        <template v-slot:body>
          <v-row no-gutters>
            <OrganizationView v-show="false" ref="orgn" :orgnOrder="contentOrgnOrder" />
            <v-card
              width="100%"
              class="print-card py-5 px-4"
              :class="[{ 'mt-4': index !== 0 }, { selected: list.checked }]"
              v-for="(list, index) in printList"
              :key="index"
              @click="clickList(list)"
            >
              <div class="d-flex justify-space-between">
                <div class="d-flex">
                  <v-checkbox
                    v-model="list.checked"
                    :true-value="true"
                    :false-value="false"
                    hide-details
                    readonly
                    :key="componentKey"
                    class="mr-3"
                  ></v-checkbox>
                  <section class="d-flex flex-column justify-space-between">
                    <div class="font-title pt-1">
                      <v-tooltip top color="primary" max-width="450px">
                        <template v-slot:activator="{ on }">
                          {{ list.minorNm }}
                          <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                        </template>
                        <div class="tooltip-text">{{ list.extra3 }}</div>
                      </v-tooltip>
                      <span v-if="list.remark" class="font-subTitle">- {{ list.remark }}</span>
                    </div>

                    <span class="font-desc pb-1">{{ list.minorDesc }}</span>
                  </section>
                </div>
                <section class="d-flex justify-center align-center">
                  <v-tooltip v-if="list.existent" top color="primary" max-width="240px">
                    <template v-slot:activator="{ on }">
                      <v-sheet color="white" rounded="lg" width="66" height="66" class="d-flex flex-column align-center justify-center" v-on="on">
                        <svg-icon icon-class="printer" style="height: 20px" class="primary--text" />
                        <div class="print-label mt-2">출력가능</div>
                      </v-sheet>
                    </template>
                    <div class="tooltip-text">{{ '출력이 가능한 문서입니다.' }}</div>
                  </v-tooltip>
                  <v-tooltip v-else top color="primary" max-width="240px">
                    <template v-slot:activator="{ on }">
                      <v-sheet color="#F2F2F3" rounded="lg" width="66" height="66" class="d-flex flex-column align-center justify-center" v-on="on">
                        <svg-icon icon-class="print_no" style="height: 20px" />
                        <div class="print-label mt-2">출력불가</div>
                      </v-sheet>
                    </template>
                    <div class="tooltip-text">{{ list.extra3 }}</div>
                  </v-tooltip>
                </section>
              </div>
            </v-card>
          </v-row>
        </template>
        <!-- <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="true" :subTitle="'절차서'" :pageTitle="'LeaderShip'" />
          </v-navigation-drawer>
        </template>-->
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnPrint="btnPrint">
          <template v-slot:customBtn>
            <v-menu content-class="report-menu" left offset-x :close-on-click="true">
              <template v-slot:activator="{ on }">
                <!-- i-button 같은 템플릿으로 한번 감쌀경우 적용이 안되어 v-btn 사용 -->
                <div v-on="on">
                  <i-icon-button color="btn_text" text="전체 출력" role="btnPrintAll" class="btnPrintAll" icon="printAll"></i-icon-button>
                </div>
                <v-divider :vertical="device === 'mobile'" />
              </template>
              <div v-for="(reportbtn, index) in reportItems" :key="`btn_${reportbtn.role}`">
                <v-divider v-if="index !== 0" style />
                <v-btn width="100%" depressed color="white" class="px-3" @click="btnPrintAll(reportbtn.role)">{{ reportbtn.title }}</v-btn>
              </div>
            </v-menu>
            <!-- <v-btn color="btn_sub" elevation="0" dark small @click="btnPrintAll()" class="rounded">전체 출력</v-btn> -->
          </template>
        </i-card-right>
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>-->
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
import notify from 'devextreme/ui/notify'
import { AesDecrypt } from '@/utils/aes256'
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import OrganizationView from '@/components/organization/OrganizationView.vue'
import iCardRight from '@/components/common/iCardRight.vue'
import iIconButton from '@/components/common/iIconButton.vue'

// API
import { getCommonCode } from '@/api/common/commonApi'
import { getRiskAssessmentOutputList, getRiskAssessmentOutputReport } from '@/api/riskAssessment/riskAssessmentOutput.js'

import { mapState } from 'vuex'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'
import { downloadAttachedFileZip } from '@/api/baseManage/fileUpload.js'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    OrganizationView,
    'i-card-right': iCardRight,
    iIconButton,
    // 절차서 컴포넌트
    ProcedureComponent,
  },

  data() {
    return {
      componentKey: 0,
      initCompId: '',
      buttonUseList: [
        'btnSearch', //조회
        'btnPrint',
      ],
      commonList: [],
      printList: [],
      docList: [],
      reportItems: [
        // { role: 'pptx', title: 'PPT' },
        { role: 'pdf', title: 'PDF' },
        { role: 'docx', title: 'DOCX' },
      ],
      contentOrgnOrder: '', // 조직도 차수
      orgn: '', // 조직도 이미지 데이터
      isDownLoading: false,
      clockTimerInterval: null,
      timeout: 0,
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
      splitPrint: true, // 분할 출력 여부
    }
  },

  computed: {
    mobileTrigger: function () {
      return this.getWidth() < 1920
    },
    elapsedTimeText() {
      const minutes = Math.floor(this.timeout / 60)
      const seconds = this.timeout % 60
      if (minutes > 0) {
        return seconds > 0 ? `${minutes}분 ${seconds}초` : `${minutes}분`
      }
      return `${seconds}초`
    },
    ...mapState({ device: (state) => state.app.device }),
  },
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    getCommonCode('RE001').then((res) => {
      if (res.success) {
        this.commonList = res.list
      }
    })
  },
  activated() {
    // if (this.changedCompFlag(this.initCompId)) {
    //   // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
    //   // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
    //   this.initCompId = this.getCompId()
    //   this.btnSearch(true)
    // }
    this.btnSearch(true)
  },
  async beforeMount() {},
  mounted() {
    this.btnSearch(true)
  },
  destroyed() {
    clearInterval(this.clockTimerInterval)
  },
  methods: {
    async btnSearch(isNotify = false) {
      this.printList = []
      this.openLoading()
      let searchParams = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
      }
      await getRiskAssessmentOutputList(searchParams, isNotify)
        .then((res) => {
          this.docList = res
          // 출력 가능여부 값 세팅
          for (const [key, value] of Object.entries(res)) {
            this.commonList.forEach((el) => {
              el.checked = false
              if (el.extra1 == key && res[key] != null) el.existent = true
              else if (el.extra1 == key && res[key] == null) el.existent = false
            })
          }
          if (this.docList.implementationRegulations) {
            this.contentOrgnOrder = this.docList.implementationRegulations[0].contentOrgnOrder
            this.$refs.orgn.btnSearch().then((res) => {})
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
          this.printList = _.clone(this.commonList)
          console.log('## this.printList', this.printList)
          // this.$refs.orgn.getExportToImage().then(data => {
          //   console.log('########## data', data.length)
          //   this.orgn = data
          // })
        })
    },
    async btnPrint(type) {
      let paramList = this.printList.filter((el) => el.checked === true)
      if (paramList.length == 0) {
        this.vSnackbar(this.$t('출력할 문서를 선택하세요.'), 'warn', 5000)
        return
      }
      this.openLoading()
      this.isDownLoading = true
      this.clockTimerInterval = setInterval(() => {
        this.timeout++
      }, 1000)
      this.$refs.orgn
        .getExportToImage()
        .then((data) => {
          this.orgn = data
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(async () => {
          paramList.forEach((el) => {
            el.params = this.docList[el.extra1]
            el.type = type
            el.clntId = this.getClntId()
            el.compId = this.getCompId()
            if (el.minorCd === '00002') el.params[0].orgn = this.orgn
          })
          console.log('### 프린트 항목1', paramList)
          paramList.forEach((el) => {
            if (el.extra1 === 'shBudget') {
              el.params.forEach((param) => {
                param.compId = this.getCompId()
              })
            }
            el.splitYn = this.splitPrint ? 'Y' : 'N'
          })
          // paramList[0].params = paramList[0].params.filter((el) => el.month === '01')
          this.openLoading({ timeout: 300000, reportApiProgress: true, reportApiTotal: 1 })
          this.trackReportApiCall(getRiskAssessmentOutputReport(paramList, false), { completed: 0, total: 1 })
            .then(async (res) => {
              const disposition = res.headers['content-disposition']

              let fileName = res.headers.filename ? res.headers.filename : 'download.' + type

              if (disposition) {
                const match = disposition.match(/filename="(.+?)"/)
                if (match && match[1]) {
                  fileName = decodeURIComponent(match[1])
                }
              }
              await this.downloadReport(res, fileName)
            })
            .catch((error) => {
              console.warn('출력 에러 발생 => ', error)
              this.isDownLoading = false
              clearInterval(this.clockTimerInterval)
              this.timeout = 0
              this.endLoading()
            })
            .finally(() => {
              this.isDownLoading = false
              clearInterval(this.clockTimerInterval)
              this.timeout = 0
              this.endLoading()
            })
        })
      // console.log('### 프린트 항목', this.docList)
    },
    btnPrintAll(type) {
      console.log('### 출력 TYPE ==> ', type)
      this.vToastifyPrompt(
        this.$t('출력 가능한 문서를 전체 출력 하시겠습니까?'),
        'info',
        (current) => {
          let printOk = this.printList.filter((el) => el.existent == true)
          // if (printOk.length === 0) {
          //   this.vSnackbar(this.$t('출력 가능한 문서가 없습니다. 문서를 작성하세요.'), 'warn', 5000)
          //   return
          // }
          // 전체 출력 로직
          this.openLoading({ timeout: 600000 })
          this.isDownLoading = true
          this.clockTimerInterval = setInterval(() => {
            this.timeout++
          }, 1000)
          this.$refs.orgn
            .getExportToImage()
            .then((data) => {
              this.orgn = data
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(async () => {
              /* 출력 가능한 문서 + 해당 절차서 */
              // let paramList = this.printList.filter(el => el.existent === true)
              // paramList.forEach(el => {
              //   el.params = this.docList[el.extra1]
              //   el.type = type
              //   el.clntId = this.getClntId()
              //   el.compId = this.getCompId()
              //   if (el.minorCd === '00002') el.params[0].orgn = this.orgn
              // })
              /* 출력 가능한 문서, 절차서 모두 출력, extra4는 절차서 출력 유무(Y:출력, N:미출력) */
              /* 출력 가능한 문서, 절차서 모두 출력, extra5는 예시 문서 출력 유무(Y:출력, N:미출력) */
              let paramList = _.cloneDeep(this.printList)
              // paramList = paramList.splice(0, 7)
              // paramList.splice(1, 4)
              paramList.forEach((el) => {
                el.params = this.docList[el.extra1] ? this.docList[el.extra1] : []
                el.type = type
                el.clntId = this.getClntId()
                el.compId = this.getCompId()
                if (el.minorCd === '00002' && el.params[0] != null) el.params[0].orgn = this.orgn
                el.splitYn = this.splitPrint ? 'Y' : 'N'
              })
              // paramList = paramList.filter(el => el.params.length > 0 || (el.params.length === 0 && el.extra4 === 'Y'))
              // 프린트 항목
              console.log('### 프린트 항목', paramList)
              // 예시 레포트 출력문서(extra5 === 'Y')는 남긴다
              paramList = paramList.filter((el) => el.params.length > 0 || (el.params.length === 0 && (el.extra4 === 'Y' || el.extra5 === 'Y')))
              paramList.forEach((el) => {
                if (el.extra1 === 'shBudget') {
                  el.params.forEach((param) => {
                    param.compId = this.getCompId()
                  })
                }
              })
              if (this.splitPrint) {
                this.splitPrintAPI(paramList)
                return
              }
              this.openLoading({ timeout: 600000, reportApiProgress: true, reportApiTotal: 1 })
              this.trackReportApiCall(getRiskAssessmentOutputReport(paramList, false), { completed: 0, total: 1 })
                .then(async (res) => {
                  const disposition = res.headers['content-disposition']
                  let fileName = res.headers.filename ? res.headers.filename : 'download.' + type
                  if (disposition) {
                    const match = disposition.match(/filename="(.+?)"/)
                    if (match && match[1]) {
                      fileName = decodeURIComponent(match[1])
                    }
                  }
                  await this.downloadReport(res, fileName)
                })
                .catch((error) => {
                  console.warn('출력 에러 발생 => ', error)
                  this.isDownLoading = false
                  clearInterval(this.clockTimerInterval)
                  this.timeout = 0
                  this.endLoading()
                })
                .finally(() => {
                  this.isDownLoading = false
                  clearInterval(this.clockTimerInterval)
                  this.timeout = 0
                  this.endLoading()
                })
            })
        },
        null,
        true
      )
    },
    trackReportApiCall(promise, progressState) {
      return promise.then((res) => {
        progressState.completed += 1
        this.updateReportLoadingProgress({
          completed: progressState.completed,
          total: progressState.total,
        })
        return res
      })
    },
    splitPrintAPI(paramList) {
      // 3개의 report(pdf blob)를 받아 zip으로 묶어서 다운로드
      const originParamList = JSON.parse(JSON.stringify(paramList))

      const tbmParamList = originParamList.filter((el) => el.extra1 === 'tbm')
      const dailyParamList = originParamList.filter((el) => el.extra1 === 'dailySafety')
      const workPlanParamList = originParamList.filter((el) => el.extra1 === 'safetyWorkPlan')
      const modifiedParamList = paramList.map((item) =>
        item.extra1 === 'tbm' || item.extra1 === 'dailySafety' || item.extra1 === 'safetyWorkPlan' ? { ...item, params: [] } : item
      )

      const reportApiCalls = [
        () => getRiskAssessmentOutputReport(modifiedParamList, false),
        () => getRiskAssessmentOutputReport(tbmParamList, false),
        () => getRiskAssessmentOutputReport(dailyParamList, false),
      ]
      if (workPlanParamList.length && workPlanParamList[0].params.length) {
        reportApiCalls.push(() => getRiskAssessmentOutputReport(workPlanParamList, false))
      }
      const reportProgress = { completed: 0, total: reportApiCalls.length }
      this.configureReportLoadingProgress({ total: reportProgress.total })

      // 동적으로 import (jszip은 dependency에 있어야 함)
      import('jszip').then((JSZip) => {
        const zip = new JSZip.default() ? new JSZip.default() : new JSZip()

        Promise.all(reportApiCalls.map((call) => this.trackReportApiCall(call(), reportProgress)))

          .then(async ([allRes, tbmRes, dailyRes, workPlanRes]) => {
            // 파일명 추출 유틸
            function extractFilename(res, fallback) {
              let fileName = fallback
              const disposition = res && res.headers ? res.headers['content-disposition'] : null
              if (res && res.headers && res.headers.filename) {
                fileName = res.headers.filename
              } else if (disposition) {
                const match = disposition.match(/filename="(.+?)"/)
                if (match && match[1]) fileName = decodeURIComponent(match[1])
              }
              return fileName
            }

            // 리포트(Blob)들을 zip에 추가
            if (allRes && allRes.data) {
              const name = extractFilename(allRes, 'all.pdf')
              zip.file(name, allRes.data)
            }
            if (tbmRes && tbmRes.data) {
              const name = extractFilename(tbmRes, 'tbm.pdf')
              zip.file(name, tbmRes.data)
            }
            if (dailyRes && dailyRes.data) {
              const name = extractFilename(dailyRes, 'daily.pdf')
              zip.file(name, dailyRes.data)
            }
            if (workPlanRes && workPlanRes.data) {
              const name = extractFilename(workPlanRes, 'workPlan.pdf')
              zip.file(name, workPlanRes.data)
            }

            // zip 파일 생성 및 다운로드
            zip.generateAsync({ type: 'blob' }).then((content) => {
              // 브라우저 다운로드
              const url = URL.createObjectURL(content)
              const a = document.createElement('a')
              a.href = url
              const now = new Date()
              const stamp = `${now.getFullYear()}.${String(now.getMonth() + 1).padStart(2, '0')}.${String(now.getDate()).padStart(2, '0')}`
              a.download = `소중안_통합문서_(${stamp}).zip`
              document.body.appendChild(a)
              a.click()

              this.isDownLoading = false
              clearInterval(this.clockTimerInterval)
              this.timeout = 0
              this.endLoading()

              setTimeout(() => {
                document.body.removeChild(a)
                URL.revokeObjectURL(url)
              }, 100)
            })
          })
          .catch((error) => {
            console.warn('zip 생성 또는 리포트 다운로드 에러 => ', error)
            this.isDownLoading = false
            clearInterval(this.clockTimerInterval)
            this.timeout = 0
            this.endLoading()
          })
          .finally(() => {})
      })
    },

    // getAttachedFileZip(paramList) {
    //   const workPlan = paramList.filter(el => el.extra1 === 'safetyWorkPlan')
    //   let fileList = []
    //   if (workPlan.length > 0) {
    //     if (workPlan[0].params.length > 0) {
    //       fileList = workPlan[0].params[0].params
    //     }
    //   } else return true
    //   if (fileList.length <= 0) {
    //     this.isDownLoading = false
    //     clearInterval(this.clockTimerInterval)
    //     this.timeout = 0
    //     this.endLoading()
    //     return
    //   }
    //   fileList.forEach(el => {
    //     el.targetType = '00024'
    //     el.targetId = `${el.clntId}_${el.compId}_${el.writeDt}`
    //   })
    //   const fileVOList = fileList.map(el => {
    //     return {
    //       targetType: el.targetType,
    //       targetId: el.targetId
    //     }
    //   })
    //   // fileVOList에서 targetId 중복제거
    //   const uniqueFileVOList = fileVOList.filter((item, index, self) => index === self.findIndex(t => t.targetId === item.targetId))
    //   return new Promise((resolve, reject) => {
    //     downloadAttachedFileZip(uniqueFileVOList)
    //       .then(res => {
    //         this.downloadZip(res, '작업계획서 첨부파일')
    //         resolve(res)
    //       })
    //       .catch(error => {
    //         this.isDownLoading = false
    //         clearInterval(this.clockTimerInterval)
    //         this.timeout = 0
    //         this.endLoading()
    //         reject(error)
    //       })
    //   })
    // },
    clickList(list) {
      if (!list.existent) {
        this.vSnackbar(this.$t(list.extra3), 'warn', 5000)
        return
      }
      this.closeVSnackbar()
      list.checked = !list.checked
      this.componentKey++
    },
  },
}
</script>

<style lang="scss" scoped>
.font-title {
  font-size: 1rem;
  font-weight: 600;
  line-height: normal;
}
.font-subTitle {
  font-size: 1rem;
  font-weight: 300;
  line-height: normal;
}
.font-desc {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: normal;
}
.print-card {
  border-radius: 8px;
  background-color: #fafafc;
  border: 1px solid transparent;
  &.selected {
    border: 1px solid #8aa6f7;
    background: #f4f8ff;
  }
  .print-label {
    font-size: 0.75rem;
    font-weight: 400;
    line-height: normal;
  }
}
.v-btn.v-size--default {
  font-size: 0.7rem;
}

// .report-menu {
//   z-index: 10 !important;
// }

.v-icon.v-icon {
  font-size: 1.2rem !important;
  padding-right: 4px;
  padding-top: 3px;
}
</style>
<style>
.iButtonList:has(.iconBtn) {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
